import React, {Component} from 'react'
import './modalWindowGroup.css'
import { connect } from 'react-redux'

import ModalWindowStorage from '../modalWindowStorage/modalWindowStorage'
import ModalWindow from '../modalWindow/modalWindow'
import ContactWindow from '../contactWindow/contactWindow'

class ModalWindowGroup extends Component {
    componentWillReceiveProps(nextProps) {

    }

    render () {
        return (
            <div className="modalWindowGroup">
                {this.props.contactModalsHidden.length > 0 && <ModalWindowStorage />}
                {this.props.contactModals &&  this.props.contactModals
                    .filter(el => this.props.contactModalsHidden.indexOf(el) < 0)
                    .map((contactId, i) => {
                    return <ModalWindow key={contactId}
                                        contactId={contactId} />
                })}
                <ContactWindow key="-1" />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        contactModals: state.contactReducer.contactModals,
        contactModalsHidden: state.contactReducer.contactModalsHidden
    }
}

export default connect(mapStateToProps)(ModalWindowGroup);


// WEBPACK FOOTER //
// ./src/common/chat/modalWindowGroup/modalWindowGroup.js